export default __webpack_public_path__ + "static/media/abyss-play.46c6595b.jpg";